import { createFileRoute } from '@tanstack/react-router'

import { EndorsementSignatureResultPage } from '../../../../../../../components/pages/subscription/checkout/endorsement-signature-result-page.tsx'

export const Route = createFileRoute(
  '/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/signature-result/',
)({
  component: EndorsementSignatureResultRoute,
})

function EndorsementSignatureResultRoute() {
  const { subscriptionId, endorsementId } = Route.useParams()
  return <EndorsementSignatureResultPage subscriptionId={subscriptionId} endorsementId={endorsementId} />
}
